module.exports = __webpack_public_path__ + "resources/loading.8939209977fbd851.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/loading/img/loading.png
// module id = 118
// module chunks = 7